import { ReactElement } from 'react';

import Link from 'next-translate-routes/link';

import { IProps } from './types';
import * as S from './styles';

export function SliceHeroImg({ slice: { primary } }: IProps): ReactElement {
  const img = <img src={primary?.img?.url || ''} alt="icon" />;

  return (
    <S.Wrapper className="slice-item slice-hero-img">
      {primary?.hero_image_link ? (
        <Link href={primary?.hero_image_link}>
          <a target="_blank" rel="noreferrer">
            {img}
          </a>
        </Link>
      ) : (
        img
      )}
    </S.Wrapper>
  );
}

SliceHeroImg.componentName = 'heroimg';
